import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { FormsModule }   from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from '../material-module';
import { NavbarComponent, AcercaComponent } from './navbar/navbar.component';
import { LoginComponent } from './login/login.component';
import { SplashComponent } from './splash/splash.component';
import { CareerComponent } from './career/career.component';
import { DatosComponent } from './datos/datos.component';
import { EscannerComponent } from './escanner/escanner.component';
import { MapaComponent } from './mapa/mapa.component';

import { AgmCoreModule } from '@agm/core';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    LoginComponent,
    SplashComponent,
    CareerComponent,
    AcercaComponent,
    DatosComponent,
    EscannerComponent,
    MapaComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBfg0hr_0FPsRVFaAo1ldOe5Te5xHOdn6w'
    })
  ],
  entryComponents: [
    AcercaComponent
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
